import debug from 'debug';
import GoogleAnalytics from 'Minetilbud/Shared/Components/GoogleAnalyticsEvents/DataLayer';
import MatomoTagManager from 'Minetilbud/Shared/Components/matomo/tag-manager';

const log = debug('FrontPageCatalogs:Utils:DataLayer');
const googleAnalytics = new GoogleAnalytics();
const matomoTagManager = new MatomoTagManager();

class DataLayer {
	static add({ customer, detail }) {
		googleAnalytics.Set({
			event: 'favorite',
			customer: customer,
			detail: detail
		});

		matomoTagManager.set({
			event: 'favorite_add',
			customer: customer,
		})
	}

	static click({ customer }) {
		matomoTagManager.set({
			event: 'favorite_click',
			customer: customer,
		})
	}

	static filterAdd({ filterName, filterType }) {
		matomoTagManager.set({
			event: 'filter_add',
			filter_name: filterName,
			filter_type: filterType
		})
	}

	static filterOverview() {
		matomoTagManager.set({
			event: 'filter_overview',
			url: window.location.href
		})
	}

	static filterRemove({ filterName, filterType }) {
		matomoTagManager.set({
			event: 'filter_remove',
			filter_name: filterName,
			filter_type: filterType
		})
	}

	static remove({ customer, detail }) {
		googleAnalytics.Set({
			event: 'favorite',
			customer: customer,
			detail: detail
		});

		matomoTagManager.set({
			event: 'favorite_remove',
			customer: customer,
		})
	}

}

export default DataLayer;
